/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accept_Button_LabelInputs */

const en_accept_button_label = /** @type {(inputs: Accept_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const nl_accept_button_label = /** @type {(inputs: Accept_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepteren`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Accept_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const accept_button_label = /** @type {((inputs?: Accept_Button_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accept_Button_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_accept_button_label(inputs)
	return en_accept_button_label(inputs)
});